import "new/initRecompose";
import angular from "angular";

export const app = angular.module("readCloudWebConsole");
